import { colors, HLine, HStack, VStack } from "goi_common";
import { ReactNode } from "react";

interface BugoSectionProps {
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  padding?: string;
}

export const BugoSection = ({
  title,
  action,
  children,
  padding = "0px 20px",
}: BugoSectionProps) => {
  return (
    <VStack
      className="subtitle_18_sb"
      padding={padding}
      width="100%"
      alignItems="stretch"
    >
      <VStack gap="8px" width="100%" alignItems="stretch">
        <HStack justifyContent="space-between" alignItems="center" width="100%">
          <div>{title}</div>
          {action || <div />}
        </HStack>
        <HLine color={colors.gray300} margin="8px 0 16px 0" height="1px" />
      </VStack>
      {children}
    </VStack>
  );
};
